export default __webpack_public_path__ + "static/media/chart-default.2dcbf14f.svg";